import ensurePath from 'redux/ensurePath'
import immerize from '../immerize'

const initialState = {
  status: '',
  error: null,
  summons_new: 0,
  summons_today: 0,
  issued: {
    loaded: false,
    error: null,
    data: {
      byid: {},
      list: [],
    },
    pagination: {
      count: 0,
      total: 0,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: 1,
    },
    typeahead: {
      staffId: [],
      name: [],
      device: [],
      omatric: [],
      oname: [],
      refnum: [],
      regnum: [],
    },
  },
  verified: {
    loaded: false,
    error: null,
    data: {
      byid: {},
      list: [],
    },
    pagination: {
      count: 0,
      total: 0,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: 1,
    },
    typeahead: {
      staffId: [],
      name: [],
      device: [],
      omatric: [],
      oname: [],
      refnum: [],
      regnum: [],
    },
  },
  rejected: {
    loaded: false,
    error: null,
    data: {
      byid: {},
      list: [],
    },
    pagination: {
      count: 0,
      total: 0,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: 1,
    },
    typeahead: {
      staffId: [],
      name: [],
      device: [],
      omatric: [],
      oname: [],
      refnum: [],
      regnum: [],
    },
  },
  billed: {
    loaded: false,
    error: null,
    data: {
      byid: {},
      list: [],
    },
    pagination: {
      count: 0,
      total: 0,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: 1,
    },
    typeahead: {
      staffId: [],
      name: [],
      device: [],
      omatric: [],
      oname: [],
      refnum: [],
      regnum: [],
    },
  },
  detail: {
    loaded: false,
    data: null,
    error: null,
  },
}

function reducer(state = initialState, action) {
  let data
  switch (action.type) {
    case 'CLEAR_STORE':
      state = initialState
      break
    case 'SUMMONS_STATISTICS_COUNT':
      data = action.payload.data

      state.error = null
      state.status = 'SUMMONS_STATISTICS_COUNT'
      state.summons_new = data.summons_new
      state.summons_today = data.summons_today
      break
    case 'SUMMONS_STATISTICS_FULFILLED':
      data = action.payload.data

      state.error = null
      state.status = 'SUMMONS_STATISTICS_FULFILLED'
      state.summons_new = data.new
      state.summons_today = data.today
      break

    case 'SUMMONS_ISSUED_ITEMPERPAGE':
      onIssuedItemPerPage(state, action.payload.count)
      break
    case 'SUMMONS_ISSUED_CURRENTPAGE':
      onIssuedCurrentPage(state, action.payload.page)
      break
    case 'SUMMONS_ISSUED_GET_FULFILLED':
      onIssuedFulfilled(state, action.payload.data)
      break
    case 'SUMMONS_ISSUED_GET_REJECTED':
      onIssuedRejected(state, action.payload.error)
      break
    case 'SUMMONS_ISSUED_CLEAR':
      onSummonsIssuedClear(state)
      break
    case 'SUMMONS_ISSSUED_TYPEAHEAD_FULFILLED':
      onIssuedTypeahed(state, action.payload.data)
      break
    case 'SUMMONS_APPROVED_ITEMPERPAGE':
      onChangeApprovedItemPerPage(state, action.payload)
      break
    case 'SUMMONS_APPROVED_CURRPAGE':
      onChangeApprovedCurrentPage(state, action.payload)
      break
    case 'SUMMONS_APPROVED_GET_FULFILLED':
      onApprovedFulfilled(state, action.payload.data)
      break
    case 'SUMMONS_APPROVED_CLEAR':
      onSummonsApprovedClear(state)
      break
    case 'SUMMONS_APPROVED_TYPEAHEAD_FULFILLED':
      onApprovedTypeahed(state, action.payload.data)
      break
    case 'SUMMONS_APPROVED_GET_REJECTED':
      onApprovedRejected(state, action.payload.error)
      break
    case 'SUMMONS_ARCHIVED_ITEMPERPAGE':
      onChangeArchivedItemPerPage(state, action.payload)
      break
    case 'SUMMONS_ARCHIVED_CURRPAGE':
      onChangeArchivedCurrentPage(state, action.payload)
      break
    case 'SUMMONS_ARCHIVED_GET_FULFILLED':
      onArchivedFulfilled(state, action.payload.data)
      break
    case 'SUMMONS_ARCHIVED_CLEAR':
      onSummonsArchivedClear(state)
      break
    case 'SUMMONS_ARCHIVED_GET_REJECTED':
      onArchivedRejected(state, action.payload.error)
      break
    case 'SUMMONS_GET_BYID_CLEAR':
      ensurePath(state, ['detail'])
      state.detail.loaded = false
      state.detail.data = null
      state.detail.error = null
      break
    case 'SUMMONS_GET_BYID_FULFILLED':
      ensurePath(state, ['detail'])
      state.detail = action.payload
      break
    case 'SUMMONS_GET_BYID_REJECTED':
      ensurePath(state, ['detail'])
      state.detail = action.payload
      break
    case 'SUMMONS_DETAIL_MODIFY_FINE':
      onDetailModifyFine(state, action.payload.val)
      break
    default:
      return state
  }
  return state
}

//= =================================================================
function onDetailModifyFine(state, val) {
  const data = ensurePath(state, ['detail', 'data'])
  data.fine = val
}

function onIssuedItemPerPage(state, count) {
  const pagination = ensurePath(state, ['issued', pagination])

  pagination.total = pagination.total ?? 0

  pagination.itemPerPage = count
  pagination.pageCount = Math.ceil(pagination.total / count)
  pagination.currentPage = 1
}

function onIssuedCurrentPage(state, page) {
  const pagination = ensurePath(state, ['issued', pagination])
  pagination.currentPage = page
}

function onIssuedFulfilled(state, incoming) {
  const normalized = onSummonNormalized(incoming)

  const data = ensurePath(state, ['issued', 'data'])
  const byid = ensurePath(state, ['issued', 'data', 'byid'])
  const pagination = ensurePath(state, ['issued', 'pagination'])

  pagination.itemPerPage = pagination.itemPerPage ?? 10
  let pageCount = Math.ceil(normalized.total / pagination.itemPerPage)
  if (pageCount < 1) {
    pageCount = 1
  }
  pagination.pageCount = pageCount

  pagination.currentPage = pagination.currentPage ?? 1
  if (pagination.currentPage > pageCount) {
    pagination.currentPage = pageCount
  }

  Object.keys(normalized.summons.byid).forEach((key) => {
    byid[key] = normalized.summons.byid[key]
  })

  data.list = data.list ?? []
  if (pagination.total !== normalized.total) {
    data.list = new Array(normalized.total).fill(-1)
  }

  if (normalized.total < 1) {
    data.list = []
  } else {
    data.list.splice(
      normalized.skip,
      normalized.summons.list.length,
      ...normalized.summons.list
    )
  }

  state.issued.error = null
  state.issued.loaded = true
  pagination.total = normalized.total
  pagination.count = normalized.count
}

function onSummonsIssuedClear(state) {
  const issued = ensurePath(state, ['issued'])

  issued.pagination = {
    count: 0,
    total: 0,
    currentPage: 1,
    itemPerPage: state.issued.pagination.itemPerPage,
    pageCount: 1,
  }
  issued.data = {
    byid: {},
    list: [],
  }

  issued.typeahead = {
    staffId: [],
    name: [],
    device: [],
    omatric: [],
    oname: [],
    refnum: [],
    regnum: [],
  }
}

function onIssuedRejected(state, e) {
  const issued = ensurePath(state, 'issued')
  issued.loaded = true
  issued.error = e
}

function onChangeApprovedItemPerPage(state, val) {
  const pagination = ensurePath(state, ['verified', 'pagination'])
  pagination.itemPerPage = val
}

function onChangeApprovedCurrentPage(state, val) {
  const pagination = ensurePath(state, ['verified', 'pagination'])
  pagination.currentPage = val
}

function onApprovedFulfilled(state, incoming) {
  const normalized = onSummonNormalized(incoming)

  const verified = ensurePath(state, ['verified'])
  const data = ensurePath(state, ['verified', 'data'])
  const byid = ensurePath(state, ['verified', 'data', 'byid'])
  const pagination = ensurePath(state, ['verified', 'pagination'])

  let pageCount = Math.ceil(normalized.total / pagination.itemPerPage)
  if (pageCount < 1) {
    pageCount = 1
  }

  pagination.currentPage = pagination.currentPage ?? 1
  if (pagination.currentPage > pageCount) {
    pagination.currentPage = pageCount
  }

  pagination.count = normalized.count
  pagination.pageCount = pageCount

  Object.keys(normalized.summons.byid).forEach((key) => {
    byid[key] = normalized.summons.byid[key]
  })

  data.list = data.list ?? []
  if (pagination.total !== normalized.total) {
    data.list = new Array(normalized.total).fill(-1)
  }
  pagination.total = normalized.total

  if (normalized.total < 1) {
    data.list = []
  } else {
    data.list.splice(
      normalized.skip,
      normalized.summons.list.length,
      ...normalized.summons.list
    )
  }

  verified.loaded = true
  verified.error = null
}

function onSummonsApprovedClear(state) {
  const verified = ensurePath(state, ['verified'])
  verified.data = {
    byid: {},
    list: [],
  }
  verified.pagination = {
    count: 0,
    total: 0,
    currentPage: 1,
    itemPerPage: state.verified.pagination.itemPerPage,
    pageCount: 1,
  }
  verified.typeahead = {
    staffId: [],
    name: [],
    device: [],
    omatric: [],
    oname: [],
    refnum: [],
    regnum: [],
  }
}

function onApprovedRejected(state, e) {
  const verified = ensurePath(state, ['verified'])
  verified.error = e
  verified.loaded = true
}

function onIssuedTypeahed(state, opts) {
  const issued = ensurePath(state, 'issued')
  issued.typeahead = { ...opts }
}

function onApprovedTypeahed(state, opts) {
  const verified = ensurePath(state, ['verified'])
  verified.typeahead = { ...opts }
}

function onChangeArchivedItemPerPage(state, val) {
  const pagination = ensurePath(state, ['rejected', 'pagination'])
  pagination.itemPerPage = val
}

function onChangeArchivedCurrentPage(state, val) {
  const pagination = ensurePath(state, ['rejected', 'pagination'])
  pagination.currentPage = val
}

function onArchivedFulfilled(state, incoming) {
  const normalized = onSummonNormalized(incoming)

  const rejected = ensurePath(state, ['rejected'])
  const data = ensurePath(state, ['rejected', 'data'])
  const byid = ensurePath(state, ['rejected', 'data', 'byid'])
  const pagination = ensurePath(state, ['rejected', 'pagination'])

  let pageCount = Math.ceil(normalized.total / pagination.itemPerPage)
  if (pageCount < 1) {
    pageCount = 1
  }

  pagination.currentPage = pagination.currentPage ?? 1
  let currentPage = pagination.currentPage
  if (pagination.currentPage > pageCount) {
    currentPage = pageCount
  }

  Object.keys(normalized.summons.byid).forEach((key) => {
    byid[key] = normalized.summons.byid[key]
  })

  data.list = data.list ?? []
  if (pagination.total !== normalized.total) {
    data.list = new Array(normalized.total).fill(-1)
  }

  if (normalized.total < 1) {
    data.list = []
  } else {
    data.list.splice(
      normalized.skip,
      normalized.summons.list.length,
      ...normalized.summons.list
    )
  }

  pagination.count = normalized.count
  pagination.total = normalized.total
  pagination.currentPage = currentPage
  pagination.pageCount = pageCount

  rejected.loaded = true
  rejected.error = null
}

function onSummonsArchivedClear(state) {
  const rejected = ensurePath(state, ['rejected'])
  rejected.data = {
    byid: {},
    list: [],
  }
  rejected.pagination = {
    count: 0,
    total: 0,
    currentPage: 1,
    itemPerPage: state.rejected.pagination.itemPerPage,
    pageCount: 1,
  }
  rejected.typeahead = {
    staffId: [],
    name: [],
    device: [],
    omatric: [],
    oname: [],
    refnum: [],
    regnum: [],
  }
}

function onArchivedRejected(state, e) {
  const rejected = ensurePath(state, ['rejected'])
  rejected.loaded = true
  rejected.error = e
}

function onSummonNormalized(issued) {
  // console.log("debug: onIssuedNormalized > issued :\n", issued);
  let { summons, ..._issued } = issued
  const _summons = {
    byid: {},
    list: [],
  }
  let count = 1
  summons.forEach((r) => {
    // console.log("debug: onIssuedNormalized > issued.ref :\n", r.ref);
    if (!_summons.byid[r.ref]) {
      _summons.list.push(r.ref)
      _summons.byid[r.ref] = r
    } else {
      _summons.list.push(r.ref + `-${count}`)
      _summons.byid[r.ref + `-${count}`] = r
      count++
    }
  })
  _issued = { ..._issued, summons: { ..._summons } }
  return _issued
}

export default immerize(reducer)
